import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <main data-testid="not-found-page" className="pt-40 pb-32 bg-[#F9F8F6] min-h-[70vh]">
      <Seo title="Page not found — ZEBO" description="The page you are looking for does not exist." path="/404" />
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <p className="overline text-[#8B0000] mb-4">404</p>
        <h1 className="font-serif text-5xl sm:text-6xl font-light tracking-tight text-[#143D63] leading-[1.02]">
          This page doesn&apos;t exist.
        </h1>
        <p className="text-[#143D63]/70 mt-6 max-w-md">
          The link may be old or mistyped. Explore our portfolio, pricing or design tools instead.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/" data-testid="notfound-home-link" className="bg-[#F8C21C] text-[#143D63] px-8 py-4 font-bold text-sm hover:bg-[#143D63] hover:text-[#F9F8F6] transition-colors">
            Back to home
          </Link>
          <Link to="/gallery" data-testid="notfound-gallery-link" className="border border-[#143D63] text-[#143D63] px-8 py-4 font-bold text-sm hover:bg-[#143D63] hover:text-[#F9F8F6] transition-colors">
            View portfolio
          </Link>
        </div>
      </div>
    </main>
  );
}
